// modules
import { listen, HistoryEvent } from 'weblite-router'
import { getOpenedRoomId, onOpenRoom } from './opened-room.service'

let lastRoomId: string = null
listen(e => {
  if (e !== HistoryEvent.POP) {
    lastRoomId = getOpenedRoomId()
    return
  }

  const roomId = getOpenedRoomId()
  if (lastRoomId === roomId) return
  lastRoomId = roomId
  if (roomId) onOpenRoom(roomId)
})
